<div class="row detail-content__row">
  <div class="col-12 col-lg-2">
    <h5 class="detail-steps__title">Attività</h5>
  </div>
  <div class="col-12 col-lg-10">
    <div class="e-icons-wrap">
      <div class="e-icons-wrap__icon e-icons-wrap__icon--blue" *ngFor="let activity of activities">
        <i [ngClass]="activity.icon"></i>
        <span>{{activity.name}}</span>
      </div>
    </div>
  </div>
</div>
